import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import NavbarId from "./data/lang/id/navbar.json";
import NavbarEn from "./data/lang/en/navbar.json";

import HeroId from "./data/lang/id/home/hero.json";
import HeroEn from "./data/lang/en/home/hero.json";

import AboutId from "./data/lang/id/home/about.json";
import AboutEn from "./data/lang/en/home/about.json";
import PodiumHomeId from "./data/lang/id/home/podium-categeory.json";
import PodiumHomeEn from "./data/lang/en/home/podium-categeory.json";
import PrizeHomeId from "./data/lang/id/home/prize.json";
import PrizeHomeEn from "./data/lang/en/home/prize.json";

import RulesRegulationId from "./data/lang/id/race-information/rules-regulation.json";
import RulesRegulationEn from "./data/lang/en/race-information/rules-regulation.json";

import faqId from "./data/lang/id/race-information/faq.json";
import faqEn from "./data/lang/en/race-information/faq.json";

import PrizeId from "./data/lang/id/race-information/prize.json";
import PrizeEn from "./data/lang/en/race-information/prize.json";

import ContactId from "./data/lang/id/contact-us.json";
import ContactEn from "./data/lang/en/contact-us.json";

import RaceDayId from "./data/lang/id/race-information/raceday.json";
import RaceDayEn from "./data/lang/en/race-information/raceday.json";

import RegistrationId from "./data/lang/id/registration.json";
import RegistrationEn from "./data/lang/en/registration.json";

import LoginId from "./data/lang/id/login.json";
import LoginEn from "./data/lang/en/login.json";

import ProfileId from "./data/lang/id/profile.json";
import ProfileEn from "./data/lang/en/profile.json";

import NotFoundId from "./data/lang/id/not-found.json";
import NotFoundEn from "./data/lang/en/not-found.json";

const resources = {
    en: {
        translation: {
            navbar: NavbarEn,
            hero: HeroEn,
            footer: {
                page: "Pages",
                social: "Social Media",
                powered: "Powered By",
                manage: "Managed By",
                govt: "Government Partner By",
                healthy: "Official Healthy Drink",
                mineral: "Official Mineral Water",
                insurance: "Official Insurance",
                cosponsor: "Co Sponsor",
            },
            home: {
                about: AboutEn,
                podium: PodiumHomeEn,
                prize: PrizeHomeEn,
                login: "Register Now",
                logout: "Logout",
                profile: "Profile",
            },
            raceinfo: {
                rrHeader: "Rules & Regulations",
                rrTitle:
                    "All participants are required to read and understand the rules and regulations below before registering for the bank bjb Bandoeng 10K.",
                rr: RulesRegulationEn,
            },
            prize: PrizeEn,
            prizeTitle: "Winner",
            raceResultTitle: "Race Result",
            faq: faqEn,
            raceday: RaceDayEn,
            racedayTitle: "Race Day",
            contact: ContactEn,
            registrationTitle: "Registration 2026",
            registrationTitleGroupOf3: "Community Exclusive Slot Group of 3 Voucher",
            registrationGroupOf3Subtitle: "Registration available only for community voucher holders.",
            registrationClosedTitle: "Registration Closed",
            redeemVoucherTitle: "Redeem Voucher",
            invitationTitle: "Invitation",
            registrationCoupon: "Dapatkan <strong>potongan sebesar Rp 225.000,-</strong> untuk program '<strong>Group of 3</strong>' dengan mendaftarkan 3 peserta  menggunakan kode kupon <strong>BANDUNGKEMBALI</strong>.",
            registration: RegistrationEn,
            galleryTitle: "Race Gallery",
            login: LoginEn,
            profile: ProfileEn,
            notFound: NotFoundEn,
        },
    },
    id: {
        translation: {
            navbar: NavbarId,
            hero: HeroId,
            footer: {
                page: "Halaman",
                social: "Media Sosial",
                powered: "Powered By",
                manage: "Managed By",
                govt: "Government Partner By",
                healthy: "Official Healthy Drink",
                mineral: "Official Mineral Water",
                insurance: "Official Insurance",
                cosponsor: "Co Sponsor",
            },
            home: {
                about: AboutId,
                podium: PodiumHomeId,
                prize: PrizeHomeId,
                login: "Daftar Sekarang",
                logout: "Keluar",
                profile: "Profil",
            },
            raceinfo: {
                rrHeader: "Peraturan & Ketentuan",
                rrTitle:
                    "Para peserta diwajibkan untuk membaca seluruh peraturan dan ketentuan dibawah ini secara seksama sebelum mendaftarkan diri untuk bank bjb Bandoeng 10K.",
                rr: RulesRegulationId,
            },
            prize: PrizeId,
            prizeTitle: "Pemenang",
            raceResultTitle: "Hasil Lomba",
            faq: faqId,
            raceday: RaceDayId,
            racedayTitle: "Pelaksanaan Lomba",
            contact: ContactId,
            registrationTitle: "Pendaftaran 2026",
            registrationTitleGroupOf3: "Voucher Community Exclusive Slot Group of 3",
            registrationClosedTitle: "Pendaftaran Ditutup",
            redeemVoucherTitle: "Redeem Voucher",
            invitationTitle: "Invitation",
            registrationGroupOf3Subtitle: "Registrasi hanya tersedia untuk peserta dengan pemegang voucher komunitas.",
            registrationCoupon: "Dapatkan <strong>potongan sebesar Rp 225.000,-</strong> untuk program '<strong>Group of 3</strong>' dengan mendaftarkan 3 peserta  menggunakan kode kupon <strong>BANDUNGKEMBALI</strong>.",
            registration: RegistrationId,
            galleryTitle: "Galeri Lomba",
            login: LoginId,
            profile: ProfileId,
            notFound: NotFoundId,
        },
    },
};

i18n.use(initReactI18next).init({
    fallbackLng: "id",
    lng: "id",
    interpolation: {
        escapeValue: false,
    },
    resources: resources,
});

export default i18n;
